import React, { useCallback, useState } from 'react'
import EditStorageModal from './EditStorageModal'
import FontAwesomeIcon from 'core/components/FontAwesomeIcon'
import { makeStyles } from '@material-ui/styles'
import Theme from 'core/themes/model'

const useStyles = makeStyles((theme: Theme) => ({
  icon: {
    display: 'inline-block',
    cursor: 'pointer',
  },
}))

export default function EditStorageButton({ vm }) {
  const classes = useStyles()
  const [showModal, setShowModal] = useState(false)

  const handleClick = useCallback(() => {
    setShowModal(true)
  }, [setShowModal])

  return (
    <>
      <div className={classes.icon} onClick={handleClick}>
        <FontAwesomeIcon size="md">edit</FontAwesomeIcon>
      </div>
      {showModal && <EditStorageModal open onClose={() => setShowModal(false)} vm={vm} />}
    </>
  )
}
